import { useQuery } from '@tanstack/react-query';
import { ApiConfigs, KeyQueryApi } from '../config/apiConfig';
 import { ResponseDashboard } from '../types/home.type';
import apiClient from '../services/api/apiClient';

 

const fetchHomeData = async (): Promise<ResponseDashboard> => {
    const response = await apiClient.get<{data: ResponseDashboard}>(`/home/index/`);
    console.log('Response from Home API:', response.data?.data);
    return response.data;
}
export const useHome = () => {
  const dashboardQuery = useQuery<ResponseDashboard>({
    queryKey: [KeyQueryApi.DASHBOARD_HOME],
    queryFn: fetchHomeData, // No need to pass language
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    dashboardQuery,
  };
};

export default useHome;
